<vi-text size="medium">
  {{ '+INSTALLATIONS.INSTALLATION.SERVICE_INSTRUCTION.MESSAGE' | translate }}
</vi-text>

<div
  class="service-instruction-container flex flex-col"
  *ngIf="!(installationDetailsStore.isServiceInstructionLoading$ | async); else loader"
>
  <ng-container *ngrxLet="selectedDocument$ | async as selectedDocument">
    <div class="document-groups-section" *ngIf="hasDocuments; else noDocuments">
      <mat-accordion [togglePosition]="'before'" class="service-instruction-accordion">
        <mat-expansion-panel *ngFor="let group of documentGroups" class="document-group-panel">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span>{{ group.documentTypeName }}</span>
              <span>({{ group.documents.length }})</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="documents-list">
            <div
              *ngFor="let document of group.documents"
              class="document-item {{ selectedDocument?.url === document.url ? 'selected' : '' }}"
              (click)="onSelectDocument(document)"
            >
              <div class="document-info">
                <span class="document-title">
                  <span class="main-title">{{ document.description || document.name }}</span>
                </span>
                <p class="print-date" *ngIf="document.printDate">
                  {{ document.printDate | date: 'mediumDate' }}
                </p>
              </div>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div class="pdf-preview-section" *ngIf="selectedDocument">
      <div class="pdf-preview-header">
        <p *ngIf="selectedDocument.description">{{ selectedDocument.description }}</p>
      </div>

      <div *ngIf="selectedDocument" [attr.data-document-key]="selectedDocument.url">
        <app-pdf-preview
          [src]="selectedDocument.url"
          [originalSize]="false"
          [showBorders]="true"
          [zoom]="0"
          [showAll]="false"
          [autoresize]="true"
          [allowNavigation]="true"
          [allowZoomScale]="true"
          [allowDownload]="true"
          gtmAction="Service instruction"
          gtmCategory="installationDetailsMenu"
          [page]="1"
          [documentTitle]="selectedDocument.name"
        ></app-pdf-preview>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #noDocuments>
  <div data-at-no-instruction-available class="flex flex-row justify-center items-center">
    {{ '+INSTALLATIONS.INSTALLATION.SERVICE_INSTRUCTION.NO_INSTRUCTION' | translate }}
  </div>
</ng-template>

<ng-template #loader>
  <vi-loader [isLoading]="true"></vi-loader>
</ng-template>
